export default __webpack_public_path__ + "static/media/favicon.22df52df.png";